import { actionTypes, IFileState } from 'src/ducks/file.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getFileStatus = (
  state: IFileState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
